import { TPersonalizedVehicle, TranslationData } from '../schema/t4-personalization/PersonalizationData';
import { ProductDto } from '../types/dls/dls-response/ProductDto';
import { OptionalResponseTypes } from '../types/GeneralTypes';
import { OfferTeaserDto } from '../types/one-search/onesearch-response/OfferTeaserResponseDto';
import { RawDataSchema } from '../types/raw/RequestParams';

export type PersonalizedVehicle = Partial<ProductDto> & TranslationData;

export async function getRawData(rawData: { schema: RawDataSchema; data: unknown }): Promise<OptionalResponseTypes> {
  if (rawData.schema === RawDataSchema.DLS) {
    return {
      ...(rawData.data as Partial<ProductDto>),
      responseTypeId: 'ProductDto',
    };
  }

  if (rawData.schema === RawDataSchema.ONE_SEARCH) {
    return {
      ...(rawData.data as Partial<OfferTeaserDto>),
      responseTypeId: 'OfferTeaserDto',
    };
  }

  if (rawData.schema === RawDataSchema.T4_PERSONALIZATION) {
    const rawT4Data = rawData.data as unknown as TPersonalizedVehicle;
    return {
      personalizedVehicle: rawT4Data,
      responseTypeId: 'T4VehicleDto',
    };
  }
  throw new Error(`This RawData Schema ${rawData.schema} is not available`);
}
